export var MEMBERS_APP_DEF_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
export var PAID_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export var MEMBERS_INFO_APP_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
export var EVENTS_APP_ID = '140603ad-af8d-84a5-2c80-a0f60cb47351';
export var EVENTS_WIDGET_ID = '1440e92d-47d8-69be-ade7-e6de40127106';
export var EVENTS_MEMBERS_WIDGET_ID = '405eb115-a694-4e2b-abaa-e4762808bb93';
export var EVENTS_DETAILS_PAGE_ID = '14d2abc2-5350-6322-487d-8c16ff833c8a';
export var EVENTS_SCHEDULE_PAGE_ID = '29ad290c-8529-4204-8fcf-41ef46e0d3b0';
export var LIVE_VIDEO_APP_ID = '2608697e-067a-44e2-8250-8e390df5bf71';
export var EVENTS_SECTION_ID = 'events';
export var MEMBERS_INFO_SECTION_ID = 'member_info';
export var MEMBERS_PAGE_SECTION_ID = 'events_members_page';
export var PAID_PLANS_SECTION_ID = 'membership_plan_picker_tpa';
export var SCHEDULE_SECTION_ID = 'Schedule';
//# sourceMappingURL=app-definitions.js.map